<template>
  <div class="login-body">
    <changePassword :changePassword="changePassword"></changePassword>
    <!-- $store.state.overlayShow -->
    <van-popup
      v-model="$store.state.isRecord"
      z-index="3000"
      :close-on-click-overlay="false"
    >
      <div class="login-register-body">
        <div class="loinLOBox">
          <img
            :src="$store.state.config.reg_page_logo"
            v-lazy="$store.state.config.reg_page_logo"
            loading="loaded"
            class="loinLOfonImg"
            v-if="!['#','hide','show'].includes($store.state.config.reg_page_logo)"
          />
          <div
            class="loinTitle"
            v-html="$store.state.config.reg_page_group"
            v-if="$store.state.config.reg_page_group != '#'"
          ></div>
        </div>
        <van-tabs
          v-model="$store.state.isRecordType"
          @click="routerFun"
          class="h"
          lineWidth="23%"
          animated
          line-height=".03rem"
          sticky
          offset-top=".9rem"
          background="var(--theme-main-bg-color)"
          :ellipsis="false"
          title-active-color="var(--theme-primary-color)"
          title-inactive-color="var(--theme-text-color-darken)"
          color="var(--theme-primary-color)"
        >
          <van-tab
            title-style="font-size: 0.26rem;"
            v-for="(item, index) in tabList"
            :title="$t(item.name)"
            :name="index"
            :key="index"
          >
            <template #title>
              <!-- color: var(--theme-text-color-lighten); -->
              <svg-icon
                className="imageWrap"
                style="width: 0.26rem; height: 0.26rem"
                :icon-class="item.icon"
              />
              {{ $t(item.name) }}
            </template>
            <component
              :is="item.content"
              ref="childRef"
              @onLogin="onLogin"
              @changePasswordFun="
                $store.commit('isRecord'), (changePassword = true)
              "
            ></component>
          </van-tab>
        </van-tabs>
        <div style="position: relative; padding: 0 0.3rem">
          <div
            class=""
            style="display: flex; align-items: center; padding-bottom: 0.2rem"
          >
            <button
              v-if="$store.state.isRecordType == 0"
              type="button"
              style="border-radius: 0.14rem"
              @click="registerUrl"
              :class="$store.state.config.reg_btn_sf ? 'GaL3XJonIwzK4ZeJyCyq' : 'GaL3XJonIwzK4ZeJyCyq2'"
            >
              {{ $t('Login._Registro') }}
            </button>
            <button
              v-else
              type="button"
              style="border-radius: 0.14rem"
              @click="loginUrl"
              :class="$store.state.config.reg_btn_sf ? 'GaL3XJonIwzK4ZeJyCyq' : 'GaL3XJonIwzK4ZeJyCyq2'"
            >
              {{ $t('Login._Login') }}
            </button>
          </div>
          <div
            v-if="
              $store.state.config.register_give &&
              $store.state.isRecordType == 0
            "
            class="uh6csli2MHzFz87__Phx tool-tips r1QnBDk2QnzYN6t7hweu"
            style="
              position: absolute;
              --cu-top: -0.05rem;
              --cu-right: -0.12rem;
              --cu-left: unset;
            "
          >
            <p
              class="tool-tips-box sNgyWmhVEZVrbSGKDBra"
              :style="{
                color: $store.state.config.ui_version == '3.7' ? '#fff' : '#fff'
              }"
            >
              {{ $t('components._Registrar') }} +
              {{ $store.state.config.register_give }}
            </p>
            <p class="tool-tips-tail YiNQnpSJUes7u5sqBZhp"></p>
          </div>
          <ul
            class="footerMensg"
            style="
              display: flex;
              align-items: center;
              color: var(--theme-primary-color);
              font-size: 0.22rem;
              line-height: 0.26rem;
              text-align: center;
            "
            :style="($store.state.isRecordType !== 0 || !$store.state.config.category_hide.includes('_Demo')) ? '' : 'justify-content: center;'"
          >
            <li
              :style="{
                width: $store.state.isRecordType !== 0 ? ($store.state.config.category_hide.includes('_Demo') ? ' 50%' :'33.3%') : (!$store.state.config.category_hide.includes('_Demo') ? ' 50%' :'')
              }"
              @click="openUrlLofin('notice')"
            >
              {{ $t('Login._Suporteaocliente') }}
            </li>
            <li
              v-if="!$store.state.config.category_hide.includes('_Demo')"
              :style="{
                width: $store.state.isRecordType !== 0 ? '33.3%' : ' 50%'
              }"
              @click="
                openUrlLofin('subgame', {
                  id: '',
                  category: 'demo'
                })
              "
            >
              {{
                !$store.state.config.category_hide.includes('_Demo')
                  ? $t('Login._JogarGrátis')
                  : ''
              }}
            </li>
            <li
              v-if="$store.state.isRecordType !== 0"
              :style="{
                width: $store.state.config.category_hide.includes('_Demo') ? ' 50%' :'33.3%'
              }"
              @click=""
            >
              {{ $t('Login._EsqueceuaSenha') }}
            </li>
          </ul>
          <div :class="[($store.state.config.ui_version != '3.7' && $store.state.config.show_quick_login) ? 'footerMensg3_7mens2' : 'footerMensg3_7mens']">
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <div class="footerMensg3_7Login">
                {{ $t('components._LoginRpido') }}
              </div>
            </div>
            <div style="display: flex;align-items: center;justify-content: center;">
              <img v-if="$store.state.config.ui_version == '3.7'" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAADyklEQVR4AeyYUVLbMBCGf7VwjsJJcE5C8kw60xsQbtCZhmfoSZKeBHoOmKr6vFZsEttZ1wSGaXaykSKtVvvvrlZ2PumD0xHAewfwGIFjBEZ64JhCIx04evl/HoFv8UzzeK2reLdhxrr8ylxT/mucpvVFl7hn/N8igBHzGPWsh7TJQkHTDT9ppS560nWaquWj7tLvVQL/kIAwl34O+wwDgAevohnd3CfqUdJacNAste2fT/qVJkzO1qSf6RN0JmlRAmEP+WkYgOfkMduMHTBkomUIug3nqaUPM878Lv8I9xs51pzoXHDUvSB090UQmS32AyDPpUJGGAp3G2ty/d/fw6Pg2zBTjhwgSFH5yA8gaCqjtZZhnOGm5+U30ZFMb9RUTvIBoFrUCm/q7qv3TLdFIUe7dxMfgKgvGy2H8H5WfiKKgSq6qNrexgvgrNTSrBzlwCt/cR7yHlG2p/rJB6BPxzwWqfzZRdZWArfHkJ/HVbmmTW9QMwraR0MB2CFrao26TBVkWvJz6jfnMJTLDqPzuF1eRSnfHM/zA1sfgFNxuNYK+jlIf50GrnyudA/ayweA3FyG8XW/srC3oUgs/Xv5APTuOHByYI7v0z4eQE4vaa0TV4pZikgL4W2No/EA6vSaiL72EEZbigBkj/D+6fEAuvbgeYYblfmg3zSH4MMAsAe/RWkwF9NnrXUg8gGgXlPTXz4TdZtkz/0SxgfN5EktVZT32r4Aq+ntxgeAy0oqkkGX8hBPlvV7wlDvX6ctCtnbW+r2f3wAso76YsojdUuEeFsj9+vRuodHSS2TKeqJcT0fgCDf84kdWns1xFhSDkCA45EiaCpkYHVQn5NalvgAtCzcGTrRLKWYAcVAjLXnHg5z0+MLkWI7CqoB1tLN54h+D3sB8DIuoZxDphbioJ5qoqBZml1vwHCQYWkh3n+Xobv+EzFV5KxcPgDNFw3zarXLVgMIvMtFxUt7PsjWvxHz6iErFiawT9ak5AOAMvOsZFGgUuhVybxflDrzXuWP/i8fAHQQUksFftlB7UonJDxMZYI55HVk171nZEuvHwBRIMclq+tEQlqlf9Riert62LB5Uq0EYIyllMJUJpg7hgXmoO4zgswW+wGwEBBUG4nKog0BJvMfXWzGdzukXlGmIfJ53gxfVH+QmYPy3J52GACUAYJKwgGlqpCv/LMGSwvZ47VaCfDIwcgaT5QPeeui/sHhAJr6AEPV4Z81GGCMNWWafeaQg5E1HuTxpjr64wCg4Z35CKA1AG84eIzAGzq7datjBFrd8oaDHz4CfwEAAP//6yWs5gAAAAZJREFUAwCqmF5wE4l6oQAAAABJRU5ErkJggg=="
              class="footerMensg3_7img" style="width: 0.7rem;height: 0.7rem;margin: 0 0.2rem;margin-top: 0.2rem;"/>
              <img :src="GoogleLOgo" class="footerMensg3_7img" style="width: 0.7rem;height: 0.7rem;margin: 0 0.2rem;margin-top: 0.2rem;"/>
              <img v-if="$store.state.config.ui_version != '3.7'" :src="fbLOgo" class="footerMensg3_7img" style="width: 0.7rem;height: 0.7rem;margin: 0 0.2rem;margin-top: 0.2rem;"/>
              <img v-if="$store.state.config.ui_version != '3.7'" :src="tgLOgo" class="footerMensg3_7img" style="width: 0.7rem;height: 0.7rem;margin: 0 0.2rem;margin-top: 0.2rem;"/>
            </div>
          </div>
        </div>
      </div>
      <div class="QzRd3YqTnYxG8Latq8fW" @click="cancelLogin">
        <img
          class="closeIcon"
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAABYCAMAAABGS8AGAAAAilBMVEUAAAD////e5Orv8vXe5Or////e5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Or////////h5+z8/f7z9ffm6/Dp7fHt8PT5+vv2+PrCEzcDAAAAJXRSTlMAYJYggoAJR6DVzbyRfHYuimpXKBlePTURrlDbxOm27OJwZaif1OMsUAAABGNJREFUWMPdmdtiojAQhlNAOSOoeK6tugRy4P1fb0lCO26DDRiv9r8Twsfkz0wSA/ovtVh6tzj8fP/4eP+M4iBdrpC93GtwJJQ1La+leNswisOgXNtQd9czpg2vNPGG4v1y/iR2lWDaVo9Ud2xv/YyxDmnqnsG77hOCOxFhC/+6znDuTsSuHdx89ZrgU5CW/nbluqutX6ZBJP1RYeN8kiEZZv2DJMr9nfbaZRL2/alZdJ3ignyIU5xvHzXaOJipVsQZaXWBG4UNi99zJuvR7LQcw00Il63xxdw2VTG02DO3dahqmuxG1Y8jw6iJY2g4V1wWH9BIFZEMmjoGLlPv302oI4eayYqLczRJKomoY/CX4wxNVI4F+bHPDpHcAk2Wp8gPcuOChQ/AnURWzx4GByEUiYNT9JQS0ds2HjSiEb1JnoDC+LABmzMCN55SIALDpVb4wn4eWSw4G0k4aR4x8b4rslAq+ky9HyOHlRFWujUiM34ELK9JI2zM0EJewyUbJVrIHuuufNpvQsT40QKB5IVsoOVsNnMRGnEDQuYh/F5S0QV9uX2rhN7QmBuQAwTWyX33osbRw6qU3nSukh5z3Hak/J/iIBut1awC8hC3mmmPlLQfLHDiiAbBQNa51R99CcL1nReOcCIZBgNZ50LEoHPHYl9pIOZLekCDHgNZ54LHoIx1QZ7758VQalUHECBrl3RtCSTYgYh5DSET2cgFkxcQfYDMZANX6dR2vi6/x455aAR5BBcFMHpiIGmJRpDNXDXt9MUW8c4VHxnII7mooN9pEXJZdwaymQvV1qoF6hPG0UQ2c5EPOfbRgfEKmcnANYHDEWAgA9cMBivswboVRzF4W3srYPD4SUs3+8G7iqw4qwJpoUDs0y2VEwQUYfqSAgEavONVJR3L/oPd0asmIVib5Jpd491rps3F3USPjjWkhe1EX1C5sQe/m/w1S9PtfnIvhcmh9WIKFm9grwnzm93yf5AWaxsj6w0LbNagDOt3yy0W9H3z75pNC+tNob7PduS+1mYbCwGy7D6tZRcuA/vrP7C/Nt/IGVTHXfrxI7LTSgacD/zhSezADvz1+nnRt+EWIjj2M7iF6EZztuC6IRd2zjXjqTx+sTCCQQJoRVOR9GkuqWTR6fJxLWwun+OmwmAeDuamR8S96PDUwMlDIVz8ckjSxk+Qr5hrxzOa/+1pshsXzH8feddpBBlfph67cdNpx0KSOZ5SgnOH1JI7R0ZyTZ3FWK6/Z5Xk7kzntrJdg7OxNvSHsfORPavpmOwoI1rD8bFJHm7l2TTZG+akZUz4pO4dYlbLB0hUrB96loVEBlDTYDN6oBPlXMUp3hergTG+xJjxSoXrTTrpupH2+8tPeEuXW3c37964c7eltz8SJu7KTpnzRzewqZTkFyHcS34TqnqsNgwjM5So7irVUvCbMwzmTtTCw6LTuuqWkShzkYV874T774TwpZDgON0ia7mHNDgdu++anT7ej3GQ+Wv0H+ov9UMLyPmx8boAAAAASUVORK5CYII="
          alt=""
        />
      </div>
    </van-popup>
  </div>
</template>

<script>
import { login } from '@/apis/modules/login.js';
import register from './register.vue';
import changePassword from './changePassword.vue';
import loIn from './loIn.vue';
import { Toast } from 'vant';
export default {
  components: {
    changePassword
  },
  props: {
    isRecord: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      GoogleLOgo: require('./../../assets/4Ddian/aoffx-gl7s6.png'),
      fbLOgo: require('./../../assets/kuaijiexiaz/Facebook.png'),
      tgLOgo: require('./../../assets/kuaijiexiaz/img_tg.png'),
      iscaptcha_configId: false,
      changePassword: false,
      activeName: 1,
      activeLength: 12,
      loain: {
        _Inscreverse: 'Registro',
        _AcessoDeMembro: 'Login'
      },
      captcha: () => {},
      conTnetfrom: {},
      rememberPassword: [],
      //_Inscreverse
      tabList: [
        {
          name: 'loain._Inscreverse',
          icon: 'login_icon_zj--svgSprite:all',
          content: register
        },
        {
          name: 'loain._AcessoDeMembro',
          icon: 'login_icon_dl--svgSprite:all',
          content: loIn
        }
      ]
    };
  },
  created() {
    let _this = this;
    if (_this.$store.state.config.captcha_config.id) {
      this.$initGeetest4(
        {
          captchaId: this.$store.state.config.captcha_config.id,
          product: 'bind',
          language: _this.$store.state.config.captcha_config.language
        },
        function (captcha) {
          _this.captcha = captcha;
          captcha
            .onReady(function () {})
            .onSuccess(function () {
              var result = captcha.getValidate();
              result.captcha_id = _this.$store.state.config.captcha_config.id;
              _this.checkComplete(_this.conTnetfrom);
            })
            .onError(function () {});
          // let co=captcha.showCaptcha();
        }
      );
    } else {
      this.iscaptcha_configId = true;
    }
  },
  methods: {
    loginUrl() {
      try {
        this.$refs.childRef[0].loginUrl();
      } catch (error) {
        this.$refs.childRef[1].loginUrl();
      }
    },
    registerUrl() {
      try {
        this.$refs.childRef[0].registerUrl();
      } catch (error) {
        this.$refs.childRef[1].registerUrl();
      }
    },
    openUrlLofin(name, quser) {
      this.openUrl(name, quser);
      this.$store.commit('isRecord');
    },
    cancelLogin() {
      this.$store.commit('isRecord');
      if (this.$store.state.isRefreshLoading) {
        setTimeout(() => {
          let alwaysShowDownload = this.$store.state.config.always_show_download;
          if (
            alwaysShowDownload &&
            !this.$store.state.config.hideAppDownload &&
            this.$store.state.config.download_give[0] == 'y'
          ) {
            this.$store.commit('publicFun', ['AppDownload', true]);
          } else {
            let inviteTime = localStorage.getItem('inviteTime');
            if (inviteTime) {
              if (inviteTime > new Date().getTime()) {
                this.$store.commit('publicFun', ['isCancelDisplay', false]);
              } else {
                this.$store.commit('publicFun', ['isCancelDisplay', true]);
              }
            } else {
              this.$store.commit('publicFun', ['isCancelDisplay', true]);
            }
            if (!this.$store.state.popList.length)
              this.$store.commit('publicFun', ['isCancelDisplay', false]);
            if (
              !this.$store.state.isCancelDisplay &&
              this.$store.state.first_recharge.status == 'show'
            ) {
              let isRechargeGiftTime =
                localStorage.getItem('isRechargeGiftTime');
              let isRechargeGift = localStorage.getItem('isRechargeGift');
              if (!isRechargeGift && !isRechargeGiftTime)
                this.$store.commit('publicFun', ['isRechargeGift', true]);
            }
          }
        }, 500);
      }
    },
    routerFun(e, l) {
      this.activeLength = l.length;
    },
    checkComplete(from = {}, rememberPassword) {
      login(from).then(({ code, data, msg }) => {
        if (code == 0) {
          this.$vuex('vuex_token_head', data);
          this.$vuex('vuex_token', data.token);
          this.$store.commit('isRecord');
          window.localStorage.setItem(
            'rememberPassword',
            JSON.stringify(this.rememberPassword)
          );
          // _this.$router.push({name:'home'});
          location.reload();
        } else {
          Toast.loading({
            message: this.myLineBreaks(msg),
            duration: 1000
          });
          // Toast.loading({

          // setTimeout(()=>{
          // 	Toast.clear()
          // },1000)
          return false;
          // })
        }
      });
    },
    onLogin(from = {}, rememberPassword) {
      if (from.account) {
        if (this.$store.state.config.register_type != 'name' && /^\d+$/.test(from.account) && from.account.length >= 10 && from.account.length <= 11) {
          from.type = 1;
        } else {
          from.type = 2;
        }
      }
      if (rememberPassword) {
        rememberPassword.unshift(from);
        this.rememberPassword = rememberPassword;
      }
      this.conTnetfrom = from;
      if (from.isZhuzhe) {
        this.rememberPassword = rememberPassword;
        this.checkComplete(from, rememberPassword);
        return false;
      }
      if (!this.iscaptcha_configId) {
        this.captcha.showCaptcha();
      } else {
        this.checkComplete(this.conTnetfrom);
      }
    }
  }
};
</script>
<style>
.loinTitle {
  font-size: 0.32rem;
}
.loinLOBox {
  text-align: center;
  color: var(--theme-primary-color);
  margin-top: 0.2rem;
}
.loinLOfonImg {
  height: 0.8rem;
}
.login-body .van-field__body input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.login-body {
  font-weight: 400;
}
.login-body .van-popup {
  background-color: transparent;
}
.login-body .van-tab--active .imageWrap {
  color: var(--theme-primary-color) !important;
}
.login-register-body .ant-select-dropdow {
  background-color: var(--theme-main-bg-color);
  border: 0.01rem solid var(--theme-color-line) !important;
  border-radius: 0.1rem;
  -webkit-box-shadow: 0 0.03rem 0.09rem 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 0.03rem 0.09rem 0 rgba(0, 0, 0, 0.1);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  z-index: 999;
  max-height: 2.75rem !important;
  overflow: hidden;
  border-radius: 0.14rem;
  width: 5rem;
  margin-top: 0.01rem;
  padding: 0.14rem 0;
}

.login-register-body .Conter_arrConte {
  display: flex;
  align-items: center;

  color: var(--theme-text-color-lighten);
  justify-content: space-between;
  font-weight: 400;
  font-size: 0.24rem;
  font-size: 0.24rem;
  line-height: 0.8rem;
  min-height: 0.8rem;
  padding: 0px 0.2rem;
}

.login-register-body .Conter_arrConte.active {
  color: var(--theme-primary-color);
}

/* color: var(--theme-primary-color); */
.login-register-body .Conter_arrConte .tengAr {
  color: var(--theme-secondary-color-error);
  font-size: 0.24rem;
}
.login-register-body .van-field__body {
  font-size: 0.22rem;
  margin-left: 0.1rem;
}
.login-register-body ul li {
  cursor: pointer;
}
html .login-register-body .van-tab__text {
  font-size: 0.26rem !important;
}
html .login-register-body .van-field__right-icon > div {
  display: flex;
  align-items: center;
}
.van-toast.van-toast--middle {
  z-index: 99999 !important;
}
.van-tabs--line .van-tabs__wrap {
  height: 0.84rem !important;
}
.csapp37 .footerMensg {
  display: none !important;
}
.footerMensg3_7 {
  display: none !important;
}
.csapp37 .footerMensg3_7 {
  display: flex !important;
}
.footerMensg3_7 {
  display: none;
}
.footerMensg3_7mens {
  display: none;
}
.footerMensg3_7mens2 {
  display: block;
  position: relative;
  padding-top: 0.2rem;
  color: var(--theme-text-color-lighten);
  font-size: 0.22rem;
}
.csapp37 .footerMensg3_7mens {
  display: block;
  position: relative;
  padding-top: 0.2rem;
  color: var(--skin__neutral_2);
  font-size: 0.22rem;
}

.csapp37 .footerMensg3_7img {
  width: 0.4663rem;
  height: auto;
  margin: 0.045rem 0.1rem 0.04rem;
  -webkit-box-shadow: 0 0.03rem 0.07rem 0 #00d9ff;
  box-shadow: 0 0.03rem 0.07rem 0 #00d9ff;
  border-radius: 100%;
}

.footerMensg3_7Login {
  position: relative;
  padding: 0 0.9rem;
}
.footerMensg3_7Login:before,
.footerMensg3_7Login:after {
  position: absolute;
  top: 50%;
  width: 0.7rem;
  height: 0.01rem;
  background-color: var(--theme-color-line);
  transform: translateY(-50%);
  content: '';
}
.footerMensg3_7Login:before {
  left: 0;
}
.footerMensg3_7Login:after {
  right: 0;
}
</style>
<style scoped>
.GaL3XJonIwzK4ZeJyCyq2 {
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  -webkit-box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);
  color: rgba(0, 0, 0, 0.65);
  cursor: pointer;
  display: inline-block;
  font-size: 14px;
  font-weight: 400;
  height: 32px;
  line-height: 1.499;
  padding: 0 15px;
  position: relative;
  text-align: center;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  white-space: nowrap;
}
.GaL3XJonIwzK4ZeJyCyq2 {
  background-color: var(--theme-primary-color);
  border-color: var(--theme-primary-color);
  font-size: 0.24rem;
  height: 0.7rem;
  width: 100%;
  color: var(--theme-primary-font-color);
  text-shadow: none;
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
}

.GaL3XJonIwzK4ZeJyCyq {
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  -webkit-box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);
  color: rgba(0, 0, 0, 0.65);
  cursor: pointer;
  display: inline-block;
  font-size: 14px;
  font-weight: 400;
  height: 32px;
  line-height: 1.499;
  padding: 0 15px;
  position: relative;
  text-align: center;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  white-space: nowrap;
}
.GaL3XJonIwzK4ZeJyCyq {
  background-color: var(--theme-primary-color);
  border-color: var(--theme-primary-color);
  font-size: 0.24rem;
  height: 0.7rem;
  width: 100%;
  color: var(--theme-primary-font-color);
  text-shadow: none;
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
  animation: _scale-btn-data 1.5s infinite;
  transition: inherit;
}
.GaL3XJonIwzK4ZeJyCyq::after {
  content: '';
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 0.14rem;
  animation: _pulse-green-data 1.5s infinite;
  transition: inherit;
}
@keyframes _pulse-green-data {
  0% {
    box-shadow: 0 0 0 0
      var(--submit-pulse-shadow-start, var(--theme-primary-color));
  }

  70% {
    box-shadow: 0 0 0 0.3rem
      var(--submit-pulse-shadow-end, rgba(0, 255, 102, 0));
  }

  100% {
    box-shadow: 0 0 0 0 var(--submit-pulse-shadow-end, rgba(0, 255, 102, 0));
  }
}
@keyframes _scale-btn-data {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
  50% {
    -webkit-transform: scale(1.08);
    transform: scale(1.08);
  }

  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}

.uh6csli2MHzFz87__Phx {
  height: 0.32rem;
  left: var(--cu-left);
  position: relative;
  right: var(--cu-right);
  top: var(--cu-top);
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  z-index: 100;
}
.r1QnBDk2QnzYN6t7hweu {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  animation: _scale-btn-data 1.5s infinite;
  transition: inherit;
  overflow: visible;
}
.uh6csli2MHzFz87__Phx .sNgyWmhVEZVrbSGKDBra {
  background-color: var(--theme-secondary-color-error);
  border-radius: 0.1rem 0.1rem 0.1rem 0;
  color: var(--theme-primary-color);
  font-size: 0.16rem;
  height: 0.22rem;
  line-height: 0.22rem;
  padding: 0 0.05rem;
}

.uh6csli2MHzFz87__Phx .sNgyWmhVEZVrbSGKDBra::after {
  content: '';
  width: 100%;
  height: 0.22rem;
  position: absolute;
  top: 0;
  left: 0;
  animation: _pulse-green-two-data 1.5s infinite;
  transition: inherit;
  border-radius: 0.1rem;
}
@keyframes _pulse-green-two-data {
  0% {
    box-shadow: 0 0 0 0
      var(--submit-pulse-shadow-start, var(--theme-secondary-color-error));
  }

  70% {
    box-shadow: 0 0 0 0.15rem
      var(--submit-pulse-shadow-end, rgba(0, 255, 102, 0));
  }

  100% {
    box-shadow: 0 0 0 0 var(--submit-pulse-shadow-end, rgba(0, 255, 102, 0));
  }
}
.uh6csli2MHzFz87__Phx .YiNQnpSJUes7u5sqBZhp {
  border-bottom: 0.07rem solid transparent;
  border-left: 0.07rem solid var(--theme-secondary-color-error);
  border-right: 0.07rem solid transparent;
  height: 0;
  width: 0;
}

.login-register-body {
  background-color: var(--theme-main-bg-color);
  border: thin solid;
  border-color: var(--theme-color-line);
  border-radius: 0.2rem;
  max-height: calc(100vh - 0.1rem);
  overflow: auto;
  width: 6.9rem;
  position: static;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  max-height: calc(100vh - 2.4rem);
  padding: 0 0 0.2rem 0;
  overflow: visible;
}
.login-body .imageWrap {
  color: var(--theme-text-color-lighten);
}
.QzRd3YqTnYxG8Latq8fW {
  -ms-flex-align: center;
  -ms-flex-pack: center;
  align-items: center;
  background: none;
  border-radius: 50%;
  bottom: -0.88rem;
  display: -ms-flexbox;
  display: flex;
  height: 0.64rem;
  justify-content: center;
  margin-right: -0.3rem;
  position: absolute;
  right: 50%;
  top: auto;
  width: 0.64rem;
  cursor: pointer;
}
.QzRd3YqTnYxG8Latq8fW .closeIcon {
  width: 100%;
  height: 100%;
}
</style>
